import styled from 'styled-components';

export const Container = styled.li`
  border-bottom: 1px solid transparent;

  &:not(:last-child) {
    border-bottom: 1px solid ${(props) => props.theme.colors.lightGrey};
  }

  a {
    text-decoration: none;
    color: black;
    padding: 16px 8px;
    transition: all 200ms;
    border-radius: 2px;
    display: flex;
    flex-direction: column;
    row-gap: 12px;

    &:hover {
      background-color: rgba(0, 0, 0, 0.05);
    }
  }
`;

export const Text = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 12px;

  .name {
    font-weight: bold;
  }

  .description {
    color: ${(props) => props.theme.colors.darkGrey};
  }

  .empty-description {
    font-style: italic;
    font-weight: lighter;
    color: ${(props) => props.theme.colors.grey};
  }
`;

export const Info = styled.div`
  display: flex;
  column-gap: 8px;
  font-weight: lighter;

  span {
    display: flex;
    align-items: center;
    column-gap: 4px;
  }
`;
